import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomainMetadata, TopLevelDomain} from '@iana-rzms/bff-sdk';
import {ChangeVO} from '../../../generate/ChangeVO';

@Component({
    selector: 'meta-data',
    templateUrl: './meta-data.component.html',
    styleUrls: ['./meta-data.component.scss'],
    standalone: false
})
export class MetaDataComponent implements OnInit {
  @Input()
  domain: TopLevelDomain;
  @Input()
  lastchange: string;
  @Input()
  change: ChangeVO;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomain>();
  editmode: boolean;
  @Input()
  viewMode: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  metaData(metadata: DomainMetadata) {
    console.log(metadata);
    this.domain.metadata = metadata;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

}
